import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    sendOtpRequest,
    sendOtpSuccess,
    sendOtpFailure,
    verifyOtpRequest,
    verifyOtpSuccess,
    verifyOtpFailure,
    resendOtpRequest,
    resendOtpSuccess,
    resendOtpFailure,
    googleLoginRequest,
    appleLoginRequest,
    socialLoginFailure,
} from "../slice/otpAuthSlice";
import { sendOtpApi, verifyOtpApi, resendOtpApi } from "../../api/apiService";
import { iframeMessaging } from "@src/utils/iframeMessaging";
import { getApiError } from "@src/utils/apiError";

// Send OTP
function* sendOtpSaga(action: PayloadAction<{ email: string }>): Generator<any, void, any> {
    try {
        const { email } = action.payload;
        yield call(sendOtpApi, { email });
        yield put(sendOtpSuccess());
    } catch (error: unknown) {
        const apiError = getApiError(error);
        yield put(
            sendOtpFailure(
                apiError.message
            )
        );
    }
}

// Verify OTP
function* verifyOtpSaga(action: PayloadAction<{ email: string; otp: string }>): Generator<any, void, any> {
    try {
        const { email, otp } = action.payload;
        const response = yield call(verifyOtpApi, { email, otp });
        const data = response.data;
        // Store tokens in localStorage
        localStorage.setItem("access_token", data.token.access);
        if (data.token.refresh) {
            localStorage.setItem("refresh_token", data.token.refresh);
        }
        // Send tokens to parent window if needed (real user only)
        iframeMessaging.sendTokenToParentIfNeeded(
            { accessToken: data.token.access, refreshToken: data.token.refresh },
            email,
        );
        yield put(
            verifyOtpSuccess({
                message: data.message,
                token: data.token,
                user_exists: data.user_exists,
            }),
        );
    } catch (error: unknown) {
        const apiError = getApiError(error);
        yield put(
            verifyOtpFailure(
                apiError.message
            )
        );
    }
}

// Resend OTP
function* resendOtpSaga(action: PayloadAction<{ email: string }>): Generator<any, void, any> {
    try {
        const { email } = action.payload;
        yield call(resendOtpApi, { email });
        yield put(resendOtpSuccess());
    } catch (error: unknown) {
        const apiError = getApiError(error);
        yield put(
            resendOtpFailure(
                apiError.message
            )
        );
    }
}

// Google Login (placeholder for future implementation)
function* googleLoginSaga(): Generator<any, void, any> {
    try {
        yield put(socialLoginFailure("Google login is not yet implemented"));
    } catch (error: unknown) {
        const apiError = getApiError(error);
        yield put(
            socialLoginFailure(
                apiError.message
            )
        );
    }
}

// Apple Login (placeholder for future implementation)
function* appleLoginSaga(): Generator<any, void, any> {
    try {
        yield put(socialLoginFailure("Apple login is not yet implemented"));
    } catch (error: unknown) {
        const apiError = getApiError(error);
        yield put(
            socialLoginFailure(
                apiError.message
            )
        );
    }
}

export function* otpAuthSaga() {
    yield takeLatest(sendOtpRequest.type, sendOtpSaga);
    yield takeLatest(verifyOtpRequest.type, verifyOtpSaga);
    yield takeLatest(resendOtpRequest.type, resendOtpSaga);
    yield takeLatest(googleLoginRequest.type, googleLoginSaga);
    yield takeLatest(appleLoginRequest.type, appleLoginSaga);
}
export { sendOtpSaga, verifyOtpSaga, resendOtpSaga, googleLoginSaga, appleLoginSaga };